import Vue from "vue";

import Router from "vue-router";
import Auth from "../templates/Auth.vue";
import ferramentas from "./ferramentas";
import produto from "./produto";
import relatorios from "./relatorios";
import saldo from "./saldo";
import usuario from "./usuario";
import vendas from "./vendas";
// import VueGtm from "vue-gtm";

Vue.use(Router);

const vueRouter = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: () => import("../views/Home.vue"),
      meta: {
        template: () => import("../templates/Base.vue"),
        protected: true
      }
    },

    ...usuario,
    ...saldo,
    ...vendas,
    ...produto,
    ...relatorios,
    ...ferramentas,

    // SURVEY
    {
      path: "/pesquisa",
      name: "survey",
      component: () => import("../views/Survey.vue"),
      meta: {
        protected: true,
        template: "div"
      }
    },

    // SUBSCRIPTIONS-MANAGER
    {
      path: "/gestao-de-assinaturas",
      name: "subscriptions-manager",
      component: () => import("../views/SubscriptionsManager.vue"),
      meta: {
        template: () => import("../templates/Base.vue"),
        protected: true,
        permissions: ["gerenciar-assinaturas"],
        viewContainer: true,
        breadcrumbs: ["subscriptions-manager"]
      }
    },

    // NEXT-RELEASES
    {
      path: "/proximos-lancamentos",
      name: "releases",
      component: () => import("../views/releases/NextReleases.vue"),
      meta: {
        template: () => import("../templates/Base.vue"),
        protected: true,
        viewContainer: true,
        breadcrumbs: ["releases"]
      }
    },
    {
      path: "/proximos-lancamentos/lancamento/:id?",
      name: "register-releases",
      component: () => import("../views/releases/RegisterReleases.vue"),
      meta: {
        template: () => import("../templates/Base.vue"),
        protected: true,
        viewContainer: true,
        breadcrumbs: ["releases", "register-releases"]
      }
    },

    // AUTH PAGES
    {
      path: "/cadastro",
      name: "register",
      component: () => import("../views/auth/Register.vue"),
      meta: {
        template: Auth,
        protected: false
      }
    },
    // {
    //   path: "/cadastro/interesse",
    //   name: "after-register",
    //   component: () => import("../views/auth/AfterRegister.vue"),
    //   meta: {
    //     template: Auth,
    //     protected: false
    //   }
    // },
    {
      path: "/login",
      name: "login",
      component: () => import("../views/auth/Login.vue"),
      meta: {
        template: Auth,
        protected: false
      }
    },
    {
      path: "/esqueci-a-senha",
      name: "forgot-password",
      component: () => import("../views/auth/ForgotPassword.vue"),
      meta: {
        template: Auth,
        protected: false
      }
    },
    {
      path: "/reset-password",
      name: "reset-password",
      component: () => import("../views/auth/ResetPassword.vue"),
      meta: {
        template: Auth,
        protected: false
      }
    },

    {
      path: "*",
      name: "not-found",
      component: () => import("../views/NotFound.vue"),
      meta: {
        template: () => import("../templates/Blank.vue"),
        protected: false
      }
    }
  ]
});

// Vue.use(VueGtm, {
//   id: "GTM-`TB4VDDF",
//   vueRouter
// });

export default vueRouter;
